<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "./assets/css/common.css";
export default {
  name: "App"
};
</script>



// WEBPACK FOOTER //
// src/App.vue